import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled, { css } from 'styled-components';
import { Banners } from '@poplar/components/Header';
import { ToastContextProvider } from '@yoweb/ui/contexts/toast/ToastContext';
import { Footer as PoplarFooter } from '@poplar/components/Footer';
import { NavGlobal } from '@poplar/components/NavGlobal';
import { AblyProvider } from '@poplar/contexts/AblyContext';
import { TaskProvider } from '@poplar/contexts/TaskContext/TaskProvider';
import { AppleItunesApp } from '@poplar/components/AppleItunesApp';
import { th } from '@yoweb/ui/styles/utils/theme';
import { media } from '@yoweb/ui/styles/utils';
import { useTranslation } from '@yoweb/next-i18next';
import { MemberActionsProvider } from '@poplar/contexts/MemberActionsProvider';
import { usePoplarBraze } from '@poplar/hooks/usePoplarBraze';
import { Box } from '@yoweb/ui/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PoplarLayout = function PoplarLayout(_ref) {
  var Footer = _ref.Footer,
      children = _ref.children,
      onboardingTask = _ref.onboardingTask,
      pageLabelKey = _ref.pageLabelKey,
      noSmallPadding = _ref.noSmallPadding,
      _ref$mobileBackground = _ref.mobileBackgroundColor,
      mobileBackgroundColor = _ref$mobileBackground === void 0 ? 'sandLight' : _ref$mobileBackground;
  usePoplarBraze();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var pageLabel = pageLabelKey && t(pageLabelKey);
  return /*#__PURE__*/_jsx(AblyProvider, {
    children: /*#__PURE__*/_jsxs(MemberActionsProvider, {
      children: [/*#__PURE__*/_jsx(AppleItunesApp, {}), /*#__PURE__*/_jsx(TaskProvider, {
        onboardingTask: onboardingTask,
        children: /*#__PURE__*/_jsxs(Layout, {
          $mobileBackgroundColor: mobileBackgroundColor,
          children: [/*#__PURE__*/_jsx(NavArea, {
            children: /*#__PURE__*/_jsx(NavGlobal, {
              pageLabel: pageLabel
            })
          }), /*#__PURE__*/_jsxs(MainArea, {
            $noSmallPadding: noSmallPadding,
            children: [/*#__PURE__*/_jsx(Box, {
              mt: {
                _: 'medium2',
                md: 'large3',
                lg: 0
              },
              children: /*#__PURE__*/_jsx(Banners, {})
            }), children]
          }), /*#__PURE__*/_jsx(FooterArea, {
            children: Footer !== null && Footer !== void 0 ? Footer : /*#__PURE__*/_jsx(PoplarFooter, {})
          })]
        })
      })]
    })
  });
};
export var getPoplarLayout = function getPoplarLayout(page, props, onboardingTask) {
  return /*#__PURE__*/_jsx(ToastContextProvider, {
    defaultPosition: "bottom-right",
    children: /*#__PURE__*/_jsx(PoplarLayout, _objectSpread(_objectSpread({
      onboardingTask: onboardingTask
    }, props), {}, {
      children: page
    }))
  });
};
var Layout = styled.div.withConfig({
  componentId: "sc-1u7efjs-0"
})(["display:grid;grid-template-areas:'nav' 'main' 'footer';", ";", ";", ";"], function (_ref2) {
  var $mobileBackgroundColor = _ref2.$mobileBackgroundColor;
  return css(["background-color:", ";"], th.getColor($mobileBackgroundColor));
}, media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), th.getColor('sandLight')), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-template-areas: 'nav main' 'footer footer';\n    grid-template-columns: fit-content(100%) 1fr;\n  "]))));
var NavArea = styled.div.withConfig({
  componentId: "sc-1u7efjs-1"
})(["grid-area:nav;"]);
var MainArea = styled.div.withConfig({
  componentId: "sc-1u7efjs-2"
})(["grid-area:main;min-height:100vh;width:100%;max-width:", ";margin:0 auto;overflow-x:auto;", " ", ";", ";"], th.getSize('containerWidth'), function (_ref3) {
  var $noSmallPadding = _ref3.$noSmallPadding;
  return $noSmallPadding ? css(["padding:0;"]) : css(["padding:", " ", " ", ";"], th.getSpace('large2'), th.getSpace('normal1'), th.getSpace('normal2'));
}, media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), th.getSpace('medium1'), th.getSpace('medium1')), media.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n  "])), th.getSpace('normal3')));
var FooterArea = styled.div.withConfig({
  componentId: "sc-1u7efjs-3"
})(["grid-area:footer;"]);